import 'css-chunksrc/client/pages/personalSpacePage/navigation/styles.scss';export default {
  "navigation": "_navigation_sxf1r_1",
  "item": "_item_sxf1r_8",
  "selectedItem": "_selectedItem_sxf1r_15",
  "icon": "_icon_sxf1r_19",
  "selectedLink": "_selectedLink_sxf1r_21",
  "text": "_text_sxf1r_26",
  "link": "_link_sxf1r_33",
  "timeSheets": "_timeSheets_sxf1r_62"
};